import React, { useState } from 'react';
import { Typography, useI18nContext } from '@procore/core-react';
import Box from '@mui/material/Box';
import { useStyles } from './BusinessMetadata.styles';

export type ProfileInfoView = 'serp' | 'profile';
type BusinessMetadataProps = {
  view: ProfileInfoView;
  Icon: React.FC;
  items: Array<any>;
  separator?: string;
  visibleOn?: Array<ProfileInfoView>;
  chopIndex?: number;
};

export default function BusinessMetadata({
  Icon,
  items,
  separator,
  view,
  visibleOn = ['serp', 'profile'],
  chopIndex = 0,
}: BusinessMetadataProps) {
  const [showMore, setShowMore] = useState(false);
  const classes = useStyles();
  const I18n = useI18nContext();
  const maxItems = chopIndex || 20;

  if (!items?.length || !visibleOn.includes(view)) {
    return null;
  }

  const itemsToShow =
    view === 'profile' && !showMore ? items.slice(0, maxItems) : items;
  const hasMoreThanMax = view === 'profile' && items.length > maxItems;
  if (chopIndex && hasMoreThanMax) {
    itemsToShow.push('...');
  }
  return (
    <Box mt={0.5} data-test-id="root">
      <Box display="flex" alignItems="flex-start">
        <Box marginRight="8px" className={classes.icon}>
          <Icon />
        </Box>
        <Box
          className={view === 'serp' ? classes.ellipsis : undefined}
          data-test-id="items-container"
        >
          <Typography data-test-id="item-text" className={classes.text}>
            {itemsToShow.join(separator || ', ')}
          </Typography>
          {!chopIndex && (
            <>
              {hasMoreThanMax && !showMore && (
                <Box
                  data-test-id="show-more-link"
                  className={classes.showMoreOrLess}
                  onClick={() => {
                    setShowMore(true);
                  }}
                >
                  <Typography color="gray50" data-test-id="show-more-link">
                    {I18n.t('components.business_metadata.show_more', {
                      amount: items.length - maxItems,
                    })}
                  </Typography>
                </Box>
              )}
              {hasMoreThanMax && showMore && (
                <Box
                  className={classes.showMoreOrLess}
                  data-test-id="show-less-link"
                  onClick={() => {
                    setShowMore(false);
                  }}
                >
                  <Typography color="gray50">
                    {I18n.t('components.business_metadata.show_less')}
                  </Typography>
                </Box>
              )}
            </>
          )}
        </Box>
      </Box>
    </Box>
  );
}
